import { Link } from "react-router";
import Styles from "./NavLink.module.css";

export function CustomNavLink({ children, path, is_active }) {
  return (
    <Link
      to={path}
      className={`${is_active && Styles.active} ${Styles.custom_nav} `}>
      {children}
    </Link>
  );
}
